/**
 * The two rules every file the browser re-encodes before sending shares, a cover and a demo film
 * alike: it is scaled down to a longest edge, never up, and it keeps the trainer's own name with
 * the extension its new bytes have. Each caller rounds the scaled sides its own way.
 */

/** The factor that brings the longest edge to at most `maxEdge`; never above 1, never an upscale. */
export function longEdgeScale(width: number, height: number, maxEdge: number): number {
  return Math.min(1, maxEdge / Math.max(width, height));
}

/** The trainer's file name with `extension` for its own, or `fallbackStem` when none is left. */
export function reencodedFileName(
  original: string,
  fallbackStem: string,
  extension: string,
): string {
  const stem = original.replace(/\.[^.]*$/, '');
  return `${stem === '' ? fallbackStem : stem}.${extension}`;
}
